import ModalEntryPoint from './ModalEntryPoint';
export default ModalEntryPoint;
